/* ============================================================
   assets/clube-supz.js
   Comportamento da landing do Clube Supz.
   Sem framework. Lê a configuração do data-* do elemento raiz,
   que a section escreve a partir do schema — nada de id ou preço
   escrito aqui dentro.
   ============================================================ */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-clube-lp]');
  if (!raiz) return;

  /* ⛔ TODO numero que entra no JS vindo de TEXTO passa por aqui (§4.5 do brief).
     `preco_membro`, `preco_nutri`, `frete_estimado`, `calc_*` sao settings do tipo
     `text` no schema desta secao, com default pt-BR: "19,90", "9,90". E
     `parseFloat('19,90')` devolve 19 — ele para na virgula. A conta de economia
     saia errada para baixo, e errava de novo em cada valor com centavos.

     ⛔ NAO trocar por `parseFloat(v.replace(',', '.'))`. Isso resolve `19,90` e
     quebra `1.234,56`, que vira `1.234` — o mesmo defeito, agora so nos valores
     altos, que sao justamente os que o cliente confere. O separador de milhar
     precisa sair ANTES da troca da virgula.

     ⛔ NAO usar em valor que JA e numero — preco vindo do Liquid em centavos ou de
     `/cart.js` ja chega inteiro. Converter duas vezes divide por 100 sem ninguem
     notar. O guarda do `typeof` no topo existe para isso. */
  function numero(v) {
    if (typeof v === 'number') { return v; }
    if (v == null) { return 0; }
    var s = String(v).replace(/[^\d,.-]/g, '');   // tira "R$", espaco, nbsp
    if (s.indexOf(',') > -1) {                     // formato pt-BR: 1.234,56
      s = s.replace(/\./g, '').replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  var cfg = {
    variantMembro: raiz.dataset.variantMembro || '',
    planoMembro:   raiz.dataset.planoMembro || '',
    variantNutri:  raiz.dataset.variantNutri || '',
    planoNutri:    raiz.dataset.planoNutri || '',
    /* Dataset ausente ou em branco cai no default; "0" continua sendo 0. */
    precoMembro:   raiz.dataset.precoMembro   ? numero(raiz.dataset.precoMembro)   : 19.90,
    precoNutri:    raiz.dataset.precoNutri    ? numero(raiz.dataset.precoNutri)    : 9.90,
    freteEst:      raiz.dataset.freteEstimado ? numero(raiz.dataset.freteEstimado) : 15,
    urlCupom:      raiz.dataset.urlCupom || '',
    termoVersao:   raiz.dataset.termoVersao || ''
  };

  var brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  /* ⛔ Normalizacao IGUAL a do endpoint: `upper(btrim())`. 44 dos 186 cupons
     da base estao gravados com caixa ou espaco fora do padrao — comparacao
     literal reprova cliente com cupom bom. O que viaja para o carrinho e o
     codigo JA normalizado, para o ingest resolver o nutri sem normalizar de
     novo dos dois lados. */
  function normaliza(s) { return String(s == null ? '' : s).trim().toUpperCase(); }

  /* Codigo validado nesta abertura do modal. Vazio = caminho sem cupom.
     ⛔ Zerado em toda abertura e em todo desvio para "sem codigo": codigo
     que sobra de uma tentativa anterior vira atribuicao a um nutri que o
     cliente nao escolheu. */
  var codigoNormalizado = '';

  /* ---------------------------------------------------------- calculadora */
  var slider = raiz.querySelector('[data-calc-slider]');
  if (slider) {
    var out = raiz.querySelector('[data-calc-valor]');
    var elDesc = raiz.querySelector('[data-calc-desconto]');
    var elCash = raiz.querySelector('[data-calc-cashback]');
    var elFrete = raiz.querySelector('[data-calc-frete]');
    var elBruto = raiz.querySelector('[data-calc-bruto]');
    var elLiq = raiz.querySelector('[data-calc-liquido]');

    var recalcula = function () {
      /* ⛔ O slider tambem e ponto de leitura: `value` sai do DOM como string, e
         `min`/`max`/`value` vem dos settings `calc_*`, que sao `text`. O helper
         vale para TODOS os pontos de leitura da calculadora, nao so o da
         mensalidade — deixar um de fora e deixar o defeito vivo num canto. */
      var P = numero(slider.value);
      var desconto = P * 0.10;
      var cashback = (P - desconto) * 0.10;
      var retorno = desconto + cashback + cfg.freteEst;

      if (out)     out.textContent = brl.format(P);
      if (elDesc)  elDesc.textContent = brl.format(desconto);
      if (elCash)  elCash.textContent = brl.format(cashback);
      if (elFrete) elFrete.textContent = brl.format(cfg.freteEst);
      /* ⛔ Restrição 3: bruto e mensalidade sempre juntos, nunca só um deles.
         Destaque no bruto é decisão do CEO (17/09). A linha do líquido abaixo
         é o que mantém a página honesta — ela sai no MESMO textContent, num
         elemento só, de propósito: separar em dois nós convida alguém a
         esconder um por CSS e deixar só o número grande na tela. */
      if (elBruto) elBruto.textContent = brl.format(retorno);
      /* ⛔ A quebra e um \n num textContent SO, com `white-space: pre-line`
         no CSS — nao dois elementos. Dois nos permitiriam esconder um por CSS
         e deixar so o numero bruto na tela, que e exatamente o que a linha
         existe para impedir. Quebra visual sim, no separado nao. */
      if (elLiq)   elLiq.textContent =
        'Menos a mensalidade de ' + brl.format(cfg.precoMembro) + ', sobram ' +
        brl.format(retorno - cfg.precoMembro) + ' por mês.\n' +
        'Com cupom de nutri a mensalidade é ' + brl.format(cfg.precoNutri) +
        ' e sobram ' + brl.format(retorno - cfg.precoNutri) + '.';
    };
    slider.addEventListener('input', recalcula);
    recalcula();
  }

  /* --------------------------------------------------------------- modal */
  var fundo = raiz.querySelector('[data-modal]');
  var modal = raiz.querySelector('[data-modal-caixa]');
  var campo = raiz.querySelector('[data-cupom-campo]');
  var erro  = raiz.querySelector('[data-cupom-erro]');
  /* Capturado antes de qualquer sobrescrita: `avisaFaltaConfig` troca o
     textContent, e sem isto a mensagem de configuracao ficaria colada na
     tela na proxima abertura do modal. */
  var erroTextoPadrao = erro ? erro.textContent : '';
  var btnSegue = raiz.querySelector('[data-cupom-segue]');
  var ultimoFoco = null;

  function abre() {
    if (!fundo) return;
    ultimoFoco = document.activeElement;
    if (campo) campo.value = '';
    codigoNormalizado = '';
    if (erro) { erro.hidden = true; erro.textContent = erroTextoPadrao; }
    if (btnSegue) btnSegue.hidden = true;
    if (modal) modal.dataset.em = 'form';
    /* ⛔ O aceite tem que voltar desmarcado a cada abertura. Aceite que fica
       marcado de uma sessao anterior nao e aceite: e caixa pre-marcada, que o
       CDC trata como clausula nao pactuada. */
    if (termo) { termo.checked = false; }
    sincronizaTermo();
    fundo.hidden = false;
    document.body.style.overflow = 'hidden';
    var alvo = modal && modal.querySelector('input, button');
    if (alvo) alvo.focus();
  }

  function fecha() {
    if (!fundo) return;
    fundo.hidden = true;
    document.body.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  Array.prototype.forEach.call(raiz.querySelectorAll('[data-abre-modal]'), function (b) {
    b.addEventListener('click', abre);
  });
  Array.prototype.forEach.call(raiz.querySelectorAll('[data-fecha-modal]'), function (b) {
    b.addEventListener('click', fecha);
  });
  if (fundo) {
    fundo.addEventListener('mousedown', function (e) { if (e.target === fundo) fecha(); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && fundo && !fundo.hidden) fecha();
  });

  /* ------------------------------------------- validação do cupom de nutri */
  var btnAplicar = raiz.querySelector('[data-cupom-aplicar]');

  /* ⛔ UMA implementacao da validacao, usada pelo botao "Aplicar" E pela
     entrada por `?cupom=`, no fim deste arquivo. Duas copias divergem na
     primeira correcao, e divergir AQUI significa a mesma cliente sendo
     aprovada por um caminho e reprovada pelo outro com o mesmo codigo. */
  function aplicaCodigo(codigo) {
    codigo = String(codigo == null ? '' : codigo).trim();
    if (!codigo) { mostraErro(); return; }

    if (!cfg.urlCupom) {
      /* ⛔ Sem endpoint configurado NÃO fingimos que validou.
         O aviso é visível e o fluxo segue como "sem cupom". */
      avisaFaltaConfig();
      return;
    }

    if (btnAplicar) btnAplicar.disabled = true;
    fetch(cfg.urlCupom + '?codigo=' + encodeURIComponent(codigo), { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) return Promise.reject(r.status);
        return r.json();
      })
      .then(function (d) {
        if (btnAplicar) btnAplicar.disabled = false;
        if (d && d.valido) {
          codigoNormalizado = normaliza(codigo);
          if (modal) modal.dataset.em = 'nutri';
        } else mostraErro();
      })
      .catch(function (e) {
        if (btnAplicar) btnAplicar.disabled = false;
        /* ⚠ NA TELA, 429 e 5xx continuam tendo o MESMO desfecho de
           `valido:false` — avisa e segue (caso 10 do §7 do endpoint, decisao
           registrada). O que muda aqui e so o console, e o motivo e novo: a
           entrada por `?cupom=` chama o endpoint uma vez por ABERTURA DE
           PAGINA, nao por clique, entao o rate limit de 10/10min por IP passa
           a ser alcancavel sem ninguem digitar nada. Sem este log, perda de
           atribuicao por 429 fica indistinguivel de cupom errado. */
        if (e === 429) {
          console.warn('[clube-supz] validacao barrada por rate limit (429): ' +
                       'a cliente segue sem cupom e a nutri perde a atribuicao.');
        }
        mostraErro();
      });
  }

  if (btnAplicar) {
    btnAplicar.addEventListener('click', function () {
      aplicaCodigo(campo && campo.value);
    });
  }

  /* ⛔ Codigo invalido e SAIDA, nao parede (decisao 2 do CEO, 18/09). A
     mensagem sai junto do botao que segue sem cupom. Travar aqui perde a
     venda de quem digitou errado ou esta com material desatualizado do
     nutri — e o cliente assina a R$ 19,90 do mesmo jeito. */
  function mostraErro() {
    if (erro) erro.hidden = false;
    if (btnSegue) btnSegue.hidden = false;
  }

  function avisaFaltaConfig() {
    /* Endpoint ausente tem a MESMA saida do codigo invalido: avisa e segue. */
    if (btnSegue) btnSegue.hidden = false;
    if (!erro) return;
    erro.hidden = false;
    erro.textContent = 'A validação de cupom ainda não está configurada nesta página. ' +
                       'Siga sem código por enquanto.';
  }

  /* ⛔ Um handler so para os DOIS botoes que levam ao caminho sem cupom.
     Dois handlers significam que um dia alguem lembra de zerar o codigo num
     e esquece do outro, e o esquecido atribui a venda a um nutri que o
     cliente abandonou na tela anterior. */
  function segueSemCupom() {
    codigoNormalizado = '';
    if (modal) modal.dataset.em = 'membro';
  }

  var btnSemCupom = raiz.querySelector('[data-sem-cupom]');
  if (btnSemCupom) btnSemCupom.addEventListener('click', segueSemCupom);
  if (btnSegue) btnSegue.addEventListener('click', segueSemCupom);

  /* ------------------------------------------------- adicionar ao carrinho */
  /* ⛔ GUARDA DE CARRINHO (camada A do brief-backstop-cobranca-dupla.md §4).
     Se JÁ existe qualquer um dos dois SKUs do Clube no carrinho, não
     adiciona o outro. Cobrança dupla de mensalidade é o defeito que esta
     guarda existe para impedir. */
  function assina(qual) {
    var variantId = qual === 'nutri' ? cfg.variantNutri : cfg.variantMembro;
    var planoId   = qual === 'nutri' ? cfg.planoNutri   : cfg.planoMembro;
    if (!variantId) { alert('Configuração incompleta: variant do Clube não definida.'); return; }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        var jaTem = (carrinho.items || []).some(function (i) {
          return String(i.variant_id) === String(cfg.variantMembro) ||
                 String(i.variant_id) === String(cfg.variantNutri);
        });
        if (jaTem) { window.location.href = '/cart'; return; }

        /* ⛔ UMA chamada so, com as propriedades no MESMO corpo do item.
           Atributo de carrinho exigiria um segundo POST /cart/update.js, e
           entre as duas chamadas existe um estado com o SKU do Clube no
           carrinho SEM cupom e SEM aceite. Esse estado vai acontecer — rede
           cai, aba fecha, o segundo fetch falha — e e o pior caso possivel:
           assinatura ativa, nutri sem atribuicao, termo sem prova.

           Chaves com `_` ficam invisiveis para o cliente e chegam ao pedido.

           ⛔ SENTINELA `SEM-CUPOM`, NAO STRING VAZIA (rev. 2 do brief, §4.1).
           Com string vazia, "o cliente disse que nao tem codigo" e "a
           propriedade nao chegou" produzem o MESMO valor no pedido, e os dois
           ficam indistinguiveis no ingest. Com a sentinela sao tres estados:

             um codigo   -> cliente validou um cupom; o ingest resolve o
                            nutri_id e grava `origem = 'cupom_clube'`
             SEM-CUPOM   -> cliente escolheu seguir sem codigo; caminho
                            normal, sem vinculo e sem alerta
             ausente     -> a propriedade nao foi enviada: DEFEITO, o ingest
                            alerta (caso 16 da §7)

           O terceiro estado e o motivo da sentinela. Sem ela, um bug aqui que
           parasse de mandar as properties produziria pedidos silenciosamente
           sem atribuicao — a §2.2 voltando por outra porta — e ninguem saberia
           por semanas. Trocar `'SEM-CUPOM'` por `''` reabre esse buraco.

           `codigoNormalizado` so tem valor no caminho do nutri: `abre()` e
           `segueSemCupom()` zeram ele. Por isso o `||` basta e nao ha
           ternario por `qual` — um caminho a menos para divergir. */
        var item = {
          id: variantId,
          quantity: 1,
          properties: {
            _cupom_nutri:     codigoNormalizado || 'SEM-CUPOM',
            _termo_versao:    cfg.termoVersao,
            _termo_aceito_em: new Date().toISOString()
          }
        };

        /* ⛔ ORIGEM DA ADESAO (019, 19/10/2026) — no MESMO `properties`, no
           MESMO POST. Quem decide o valor e o assets/supz-origem.js; aqui so
           se copia. Os mesmos TRES ESTADOS da sentinela acima:

             valor da taxonomia -> o supz-origem.js achou um sinal
             `direto`           -> piso: o modulo rodou e nao achou sinal
             ausente            -> o supz-origem.js NAO rodou: DEFEITO, e tem
                                   de continuar detectavel no pedido

           Por isso NAO ha `|| 'direto'` quando o modulo falta: preencher o piso
           ali apagaria o terceiro estado, como `''` apagaria o do cupom. E
           nunca string vazia — os detalhes e as UTMs so entram quando tem
           valor. O `try` existe porque falha na origem nao pode custar a
           assinatura. */
        var origem = null;
        try { origem = window.supzOrigem ? window.supzOrigem.atual() : null; } catch (e) { origem = null; }
        if (origem) {
          item.properties._origem = origem.origem || 'direto';
          if (origem.detalhe)      item.properties._origem_detalhe = origem.detalhe;
          if (origem.utm_source)   item.properties._utm_source     = origem.utm_source;
          if (origem.utm_medium)   item.properties._utm_medium     = origem.utm_medium;
          if (origem.utm_campaign) item.properties._utm_campaign   = origem.utm_campaign;
        }

        if (planoId) item.selling_plan = planoId;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { return Promise.reject(e); });
          window.location.href = '/checkout';
        });
      })
      .catch(function (e) {
        console.error('[clube-supz] falha ao adicionar ao carrinho', e);
        alert('Não conseguimos abrir o checkout agora. Tente de novo em instantes.');
      });
  }

  /* ------------------------------------------ video: area toda clicavel */
  var vid = raiz.querySelector('[data-video-nutri]');
  var capa = raiz.querySelector('[data-video-inicia]');
  if (vid && capa) {
    var caixaVideo = capa.parentNode;
    var revela = function () { if (caixaVideo) caixaVideo.dataset.tocou = '1'; };
    capa.addEventListener('click', function () {
      revela();
      var p = vid.play();
      /* play() devolve Promise nos navegadores atuais. Sem o catch, autoplay
         bloqueado vira "Unhandled rejection" no console do cliente. */
      if (p && p.catch) p.catch(function () {});
    });
    /* Se o play vier por outro caminho (teclado na barra nativa, por exemplo),
       a capa tambem tem que sair — senao ela fica por cima do video tocando. */
    vid.addEventListener('play', revela);
  }

  /* ------------------------------------ etapa 2: termo + assinar, no modal */
  /* ⛔ O aceite saiu da secao de fechamento e virou a trava do UNICO botao que
     adiciona ao carrinho. Antes ele desabilitava so o CTA final; o CTA do hero
     abria o mesmo modal por fora e dava para assinar sem nunca ter marcado
     nada. Com cinco CTAs na pagina esse furo viraria o caminho normal.

     ⛔ A trava mora aqui, no clique que monta o carrinho, e nao no botao que
     abre o modal. Botao de abrir e enfeite: da para ter dez deles. Ponto de
     controle tem que ser um so, e ser o ultimo. */
  var termo = raiz.querySelector('[data-termo]');
  var btnAssina = raiz.querySelector('[data-assina-atual]');

  function sincronizaTermo() {
    if (btnAssina) btnAssina.disabled = !(termo && termo.checked);
  }
  if (termo) termo.addEventListener('change', sincronizaTermo);

  if (btnAssina) {
    btnAssina.addEventListener('click', function () {
      /* ⛔ Segunda checagem, alem do `disabled`. `disabled` e estado de UI e
         some com um clique no inspetor; esta linha e a que de fato impede. */
      if (!termo || !termo.checked) return;
      var em = modal && modal.dataset.em;
      if (em !== 'nutri' && em !== 'membro') return;
      assina(em);
    });
  }

  var btnVolta = raiz.querySelector('[data-volta-cupom]');
  if (btnVolta) {
    btnVolta.addEventListener('click', function () { if (modal) modal.dataset.em = 'form'; });
  }

  /* ---------------------------------- entrada por `?cupom=` (019, 20/10/2026) */
  /* O link de atendimento abre a LP com o codigo da nutri na URL. O modal sobe
     JA VALIDADO, no estado `nutri`: a cliente marca o termo e confirma. Dois
     toques, e dois e o piso — o terceiro a menos seria pre-marcar o aceite, e
     caixa pre-marcada nao e aceite (CDC).

     ⛔ A VALIDACAO NAO E PULADA. Este caminho chama o MESMO `aplicaCodigo()`
     do botao "Aplicar"; o que muda e o gatilho, nao a regra. `codigoNormalizado`
     continua so recebendo valor depois de `valido: true` vir do endpoint.

     ⛔ ESTE BLOCO FICA NO FIM DO ARQUIVO, e nao junto do resto do modal.
     `abre()` le `termo` e chama `sincronizaTermo()`, que le `btnAssina` — as
     duas sao `var` declaradas acima, perto do fim. Rodando antes delas, o
     hoisting entrega `undefined` nas duas e a limpeza do aceite simplesmente
     nao acontece. Subir este bloco quebra essa limpeza SEM quebrar nada
     visivel, que e o pior tipo de regressao.

     ⛔ E a ordem interna e `abre()` PRIMEIRO, campo DEPOIS. O `abre()` zera o
     campo e o `codigoNormalizado` de proposito: codigo que sobra de uma
     tentativa anterior vira atribuicao a uma nutri que a cliente nao escolheu.
     Preencher antes de abrir seria apagado — e tirar a limpeza do `abre()`
     para "resolver" isso reabre exatamente aquele defeito. */
  function paramDaUrl(nome) {
    try {
      var v = new URLSearchParams(window.location.search).get(nome);
      return v == null ? '' : String(v).trim();
    } catch (e) { return ''; }
  }

  var cupomDaUrl = paramDaUrl('cupom');
  if (cupomDaUrl) {
    abre();
    if (campo) campo.value = cupomDaUrl;
    /* Codigo invalido cai no `form` COM o campo preenchido, a mensagem de erro
       e o botao de seguir sem codigo: o mesmo desfecho de quem digita errado.
       Erro continua sendo saida, nao parede (decisao 2 do CEO, 18/09). */
    aplicaCodigo(cupomDaUrl);
  }
})();
